// src/components/CustomSidebar.tsx
import { Sidebar, useSidebarState } from "react-admin";
import DynamicMenu from "./DynamicMenu.tsx";

import PersonIcon from "@mui/icons-material/Person";

import BadgeIcon from "@mui/icons-material/Badge";
// 或者
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
// 或者
import ListIcon from "@mui/icons-material/List";
// 或者
import MenuBookIcon from "@mui/icons-material/MenuBook";
// 或者
import ViewListIcon from "@mui/icons-material/ViewList";
import CategoryIcon from "@mui/icons-material/Category";
// 或者
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// 或者
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// 或者
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import ContactsIcon from "@mui/icons-material/Contacts";
import GroupIcon from "@mui/icons-material/Group";

import FolderIcon from "@mui/icons-material/Folder";
import { ContactIcon } from "lucide-react";

const CustomSidebar = (props: any) => {
  const [sidebarIsOpen] = useSidebarState();
  return (
    <Sidebar
      {...props}
      sx={{
        height: "auto",
        minHeight: "100vh",
        position: "sticky",
        top: 0,
        maxWidth: 200,
      }}
    >
      <DynamicMenu sidebarIsOpen={sidebarIsOpen} />
    </Sidebar>
  );
};

export default CustomSidebar;
